module.exports = __webpack_public_path__ + "images/c97d610b.png";